import { Button } from '@/components/ui/button';
import { Trash2, DollarSign, UserPlus, X } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const BulkActionBar = ({
  selectedCount,
  onClear,
  onDelete,
  onReprice,
  onReassign,
}) => {
  const { t } = useLanguage();
  if (selectedCount === 0) return null;

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 bg-card border border-border shadow-2xl rounded-md px-4 py-3 flex items-center gap-3 backdrop-blur-md"
      data-testid="bulk-action-bar"
    >
      <span className="text-sm font-bold" data-testid="bulk-selected-count">
        {selectedCount} {t('admin.bulkSelected')}
      </span>
      <div className="h-5 w-px bg-border" />
      <Button
        variant="outline" size="sm"
        onClick={onReprice}
        data-testid="bulk-reprice-btn"
      >
        <DollarSign className="w-4 h-4 mr-1" />
        {t('admin.bulkReprice')}
      </Button>
      <Button
        variant="outline" size="sm"
        onClick={onReassign}
        data-testid="bulk-reassign-btn"
      >
        <UserPlus className="w-4 h-4 mr-1" />
        {t('admin.bulkReassign')}
      </Button>
      <Button
        variant="outline" size="sm"
        onClick={onDelete}
        className="text-destructive hover:text-destructive hover:bg-destructive/10 border-destructive/40"
        data-testid="bulk-delete-btn"
      >
        <Trash2 className="w-4 h-4 mr-1" />
        {t('admin.bulkDelete')}
      </Button>
      <div className="h-5 w-px bg-border" />
      <Button
        variant="ghost" size="icon"
        onClick={onClear}
        title={t('admin.bulkClearSelection')}
        data-testid="bulk-clear-btn"
        className="h-8 w-8"
      >
        <X className="w-4 h-4" />
      </Button>
    </div>
  );
};
